// ===========================================
// hooks/useIntersectionObserver.js
// ===========================================
import { useEffect, useRef, useState } from 'react';

export const useIntersectionObserver = (options = {}) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [entry, setEntry] = useState(null);
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element || options.disabled) {
      setIsIntersecting(false);
      return;
    }

    // Check if IntersectionObserver is supported
    if (!window.IntersectionObserver) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Add a small delay to prevent rapid firing
        setTimeout(() => {
          setIsIntersecting(entry.isIntersecting);
          setEntry(entry);
        }, 100);
      },
      {
        threshold: 0.1,
        rootMargin: '50px', // Reduced margin to be less aggressive
        ...options
      }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [options, options.disabled]);

  return {
    elementRef,
    isIntersecting,
    entry
  };
};